import { render, staticRenderFns } from "./PackageResults.vue?vue&type=template&id=2b3900f9&scoped=true"
import script from "./PackageResults.vue?vue&type=script&lang=ts"
export * from "./PackageResults.vue?vue&type=script&lang=ts"
import style0 from "./PackageResults.vue?vue&type=style&index=0&id=2b3900f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.106.2__lodash@4.18.1_pug@3.0.4_underscor_544b6cb00681b26f8947ee228cf90691/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3900f9",
  null
  
)

export default component.exports